module.exports = __webpack_public_path__ + "static/img/lunbo1.352ffa4a.jpeg";